﻿export default {
    methods: {       
        signNow()
        {
            //Main signing function that tests for browser type.
            //IE uses a java  and ActiveX plugin for signing.
            //FireFox and Chrome uses extentions for signing.

            //Store the canvas object and get the context to manipulate image data.
            this.canvasObj = document.getElementById('cnv');
            this.canvasContext = this.canvasObj.getContext('2d');

            this.imgWidth = this.canvasObj.width;
            this.imgHeight = this.canvasObj.height;

            //Clear canvas to remove recent signature
            this.canvasContext.clearRect(0, 0, this.imgWidth, this.imgHeight);

            // Internet Explorer 6-11
            var isIE = /*@cc_on!@*/false || !!document.documentMode;
            if(isIE)
            {
                //this.signNowIE();
                this.signNowIEAXVersion();
            }
            else //All other browsers
            {
                this.signNowFFChrome();
            }
        },
        signNowFFChrome() //Signing for FireFox and Chrome using brower extension
        {            
            //Setup the browser extention and convert to JSON.
            var message = { "firstName": this.contracts.signatureOwnerFullName, "lastName": "", "eMail": "", "location": "", "imageFormat": 1, "imageX": this.imgWidth, "imageY": this.imgHeight, "imageTransparency": false, "imageScaling": false, "maxUpScalePercent": 0.0, "rawDataFormat": "ENC", "minSigPoints": 25, "penThickness": 3, "penColor": "#000000" };
            var messageData = JSON.stringify(message);
        
            //Assing the event listener for capturing the signature data.
            document.addEventListener('SigCaptureWeb_SignResponse', this.SignResponse, false);
                
            var element = document.createElement("SigCaptureWeb_ExtnDataElem");
            element.setAttribute("SigCaptureWeb_MsgAttribute", messageData); //Request data
            document.documentElement.appendChild(element);

            var evt = document.createEvent("Events");
            evt.initEvent("SigCaptureWeb_SignStartEvent", true, false);				
        
            element.dispatchEvent(evt);		
        },       
        SignResponse(event) //Used for FF/Chrome version. This captures the response and graphical data from the browser extention.
        {
            var responseString = event.target.getAttribute("SigCaptureWeb_msgAttri"); //Response data
            var response = JSON.parse(responseString);
        
            if (response.errorMsg != null && response.errorMsg!="" && response.errorMsg!="undefined") //Errors and cancellations
            {
                alert(response.errorMsg);
            }
            else
            {
                if (response.isSigned)
                {   
                    this.DrawSignature(this.canvasContext, response.imageData, this.imgWidth, this.imgHeight);
                }
            }
        },
        DrawSignature(canvasContext, imageData, width, height) //Draws the image data onto the canvas. The canvas context has to passed along because the image onload function can't accees the global context.
        {
            this.showCanvas = true;

            var signatureElement = document.getElementById('ContractsSignitureCreditAccountBlock_SignatureString');
            signatureElement.value = imageData;

            var img = new Image();
            img.onload = function () 
            {
                canvasContext.drawImage(img, 0, 0, width, height);
            }
            img.src = "data:image/png;base64," + imageData;            
            if(this.digitalSigningModal.multipleSignatures)
            {
                this.$store.dispatch('signContractsByName', {'orderId': this.order.orderId, 'dealerCode': this.order.dealerCode, 'channelType': this.order.channelType, 'userId': this.order.salesAgent,'signatureString' : imageData, 'loaderTitle':this.pageLoader.loaderSubmitOrderTitle, 'loaderMessage':this.pageLoader.loaderSubmitOrderMessage, 'signer': this.digitalSigningModal.selectedSigner});          
            }
            else{                
                this.$store.dispatch('signContracts', {'orderId': this.order.orderId, 'dealerCode': this.order.dealerCode, 'channelType': this.order.channelType, 'userId': this.order.salesAgent,'signatureString' : imageData, 'loaderTitle':this.viewmodel.getSubmitOrderLoaderTitle, 'loaderMessage':this.viewmodel.getSubmitOrderLoaderMessage});          
            }            
            this.showSignatureButton = false;
        },
        signNowIEAXVersion()
        {
            var id = Math.floor((Math.random() * 10) + 1);
            var idstring = id.toString();

            // The thickness can be in the range of 1 - 9, anything above 9 will be treated as the default value 2.
            document.esCapture1.EnableAntiAliasing = true;
         
            if(this.contracts.signatureOwnerFullName == "")
            {
                document.esCapture1.ShowSignerName = false;        
            }
            else{               
                document.esCapture1.ShowSignerName = true;   
                document.esCapture1.SetSignerDetailsEx(this.contracts.signatureOwnerFullName, '', '', '', '', '', '', '')
            }
            document.esCapture1.EnableWhiteSpaceRemoval = true;
            document.esCapture1.EnableMaxEnlargementFeature = true;
            document.esCapture1.MaxEnlargementFactor = 1.25;
                   
            //Exceute the jar element. This is not asyncronous so later code will not be executed until java applet is closed
            document.esCapture1.StartSign(1,1);

            var isSigned = document.esCapture1.isSigned;
            if (isSigned == true) // Information can only be extracted if isSigned() returns true
            {
                // Get the signature info and assign to one of form field              
                var signatureString = document.esCapture1.GetSignData();        
                var jpgData = document.esCapture1.GetImageData( this.imgWidth, this.imgHeight, 1, 100);
                this.DrawSignature(this.canvasContext, jpgData, this.imgWidth, this.imgHeight);
            }
        },
        signNowIE()
        {            
            var id = Math.floor((Math.random() * 10) + 1);
            var idstring = id.toString();

            // The thickness can be in the range of 1 - 9, anything above 9 will be treated as the default value 2.
            document.Sign.setSignThickness(2);
            document.Sign.enableWhiteSpaceRemoval(true);
            document.Sign.enableMaxEnlargementFactor(true);
            document.Sign.setMaxEnlargementFactor(1.25);
            document.Sign.setEnableLCDButtons(false);
       
            //Exceute the jar element. This is not asyncronous so later code will not be executed until java applet is closed
            document.Sign.signNowEx(idstring, "Telia signature", true);
            var isSigned = document.Sign.isSigned();
            if (isSigned == true) // Information can only be extracted if isSigned() returns true
            {
                // Get the signature info and assign to one of form field
                var signatureString = document.Sign.getString();
            
                var pngData = document.Sign.getPNGString(signatureString, this.imgWidth, this.imgHeight, true);
                var jpgData = document.Sign.getJpegString(signatureString, this.imgWidth, this.imgHeight, 100);

                this.DrawSignature(this.canvasContext, jpgData, this.imgWidth, this.imgHeight);
            }
        }        
    } 
}